import { useState } from "react";
import { useDispatch } from "react-redux";
import { Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";

import ProductSubmissionModal from "./ProductSubmissionModal";
import ProductErrorModal from "./ProductErrorModal";
import ErrorPopup from "./ErrorPopup";
import { useProductSlice } from "../helpers/helpers";
import validateProductStep from "../validations/validateProductStep";
import ImageUploadModal from "@components/ImageUploadModal";
import { finalSubmitProduct } from "../helpers/submission";

const HandleSteps = ({
  step,
  prev,
  next,
  totalSteps,
  sepratorOne,
  SeparatorTwo,
  isLoadingbtn,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [submittedId, setSubmittedId] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [popupError, setPopupError] = useState("");

  const selectedProduct = useProductSlice();
  const productType = localStorage.getItem("product");

  const progress = (step / totalSteps) * 100;
  const left = (sepratorOne / totalSteps) * 100;
  const right = (SeparatorTwo / totalSteps) * 100;

  const handleNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    next();
    setTimeout(() => {
      setIsTransitioning(false);
    }, 10);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setPopupError("");

    const validationError = validateProductStep(
      productType,
      selectedProduct,
      step,
      t
    );

    if (validationError) {
      setIsLoading(false);
      setPopupError(validationError);
      return;
    }

    try {
      const result = await finalSubmitProduct(selectedProduct);
      setSubmittedId(result?.id || null);
      setShowModal(true);
    } catch (error) {
      console.error("Error submitting product:", error);
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* ✅ Bottom navigation - Static position */}
      <div
        className={`bg-white w-100 mt-auto ${step === 0 && "border-top"}`}
        
      >
        <div
          className={`progress-bar-container w-100 ${step === 0 && "d-none"}`}
          style={{ height: "5px", overflow: "hidden", background: "#DDDDDD" }}
        >
          <div
            className="bg-blue h-100 position-relative"
            style={{ width: `${progress}%`, transition: "width 0.6s ease" }}
          >
            <div
              style={{
                position: "absolute",
                left: `${left}%`,
                width: "10px",
                height: "10px",
                backgroundColor: "white",
                top: "-2.5px",
              }}
            />
            <div
              style={{
                position: "absolute",
                left: `${right}%`,
                width: "10px",
                height: "10px",
                backgroundColor: "white",
                top: "-2.5px",
              }}
            />
          </div>
        </div>

        <div className="container py-3">
          <Row className="justify-content-between align-items-center">
            <Col xs="5">
              <button
                type="button"
                onClick={prev}
                className="bg-white fs-5 fw-bold text-decoration-underline text-dark border-0"
                disabled={step < 2 || isTransitioning}
              >
                {t("back")}
              </button>
            </Col>
            <Col
              xs="5"
              sm="4"
              md="3"
              lg="2"
              className="d-flex justify-content-end"
            >
              {step < totalSteps && (
                <button
                  onClick={handleNext}
                  type="button"
                  className="fs-6 btn-blue py-3 w-100 rounded-5 text-white border-0"
                  style={{ opacity: isLoading ? "0.6" : "" }}
                  disabled={isLoading || isTransitioning}
                >
                  {isLoading || isLoadingbtn ? <Loader size="xs" /> : t("next")}
                </button>
              )}

              {step === totalSteps && (
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="fs-6 btn-blue p-3 w-100 rounded-5 text-white border-0"
                  style={{ opacity: isLoading ? "0.6" : "" }}
                  disabled={isLoading}
                >
                  {isLoading ? <Loader size="xs" /> : t("confirm")}
                </button>
              )}
            </Col>
          </Row>
        </div>
      </div>

      {productType === "Activity" ||
        productType === "Car" ||
        productType === "Transport" ? (
        <ImageUploadModal
          open={showModal}
          onClose={() => setShowModal(false)}
          productId={submittedId}
        />
      ) : (
        <ProductSubmissionModal
          open={showModal}
          onClose={() => setShowModal(false)}
          productId={submittedId}
        />
      )}

      <ProductErrorModal
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
      />

      {/* Validation/Error popup */}
      <ErrorPopup
        open={!!popupError}
        onClose={() => setPopupError("")}
        message={popupError}
      />
    </>
  );
};

export default HandleSteps;